module.exports = __webpack_public_path__ + "img/bcg-right-purple.ef4f08f0.png";